import { jotaiStore } from '@shared/store/jotai/jotai-store';

import { subscriptionAtom, type SubscriptionStoreState } from '@entities/subscription/store/subscription.atom';

const applySubscription = (next: (prev: SubscriptionStoreState) => SubscriptionStoreState): void => {
  jotaiStore.set(subscriptionAtom, next);
};

export const changePaymentMethod = (paymentMethod: string): void => {
  applySubscription((prev) => ({ ...prev, paymentMethod }));
};

export const formWasSubmitted = (): void => {
  applySubscription((prev) => ({ ...prev, btnLoading: true }));
};

export const formResultRetrieved = (): void => {
  applySubscription((prev) => ({ ...prev, btnLoading: false }));
};

export const formResetComplete = (): void => {
  applySubscription((prev) => ({ ...prev, needToResetForm: false }));
};

export const gpayReceivedd = (): void => {
  applySubscription((prev) => ({ ...prev, gpayReceived: true, gpayLoading: true }));
};

export const gpayLoaded = (): void => {
  applySubscription((prev) => ({ ...prev, gpayLoading: false }));
};

export const writeSubscriptionBtnLoading = (btnLoading: boolean): void => {
  applySubscription((prev) => ({ ...prev, btnLoading }));
};

export const writeSubscriptionCcUnsubscribeSuccess = (): void => {
  applySubscription((prev) => ({
    ...prev,
    btnLoading: false,
    needToResetForm: true,
  }));
};

export const writeSubscriptionDcbUnsubscribeSuccess = (data: Record<string, unknown>): void => {
  applySubscription((prev) => ({
    ...prev,
    unsubscribeData: data,
    btnLoading: false,
    needToResetForm: true,
  }));
};
